import Image from './Image';
import { ImageCombinedProps, ImageProps, ImageValueProps } from './types';

export type { ImageCombinedProps, ImageProps, ImageValueProps };
export default Image;
